import CurrentlyPursuingDetails from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/CurrentlyPursuingDetails'
import EducationSection from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/EducationSection'
import HonorsAwardsSection from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/HonorsAwardsSection'
import InfoSection from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/InfoSection'
import OtherDetails from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/OtherDetails'
import SocialMediaLinks from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/SocialMediaLinks'
import WorkExperienceSection from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/WorkExperienceSection'
import React, { Fragment } from 'react'

import {
  Main,
  MainHeading,
  StyledDivider,
  StyledP,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const StudentDrawerContent = ({ studentData, singleStudentData }) => {
  return (
    <Main>
      {singleStudentData?.resume?.objective ? (
        <Fragment>
          <MainHeading marginBottom="15px">Career Objective</MainHeading>
          <StyledP>{studentData?.resume?.objective}</StyledP>

          <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.educationProfile?.length ? (
        <Fragment>
          <EducationSection studentData={singleStudentData} /> <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.resume?.projects?.length ? (
        <Fragment>
          <MainHeading>Project</MainHeading>
          <SubFLex column gap="25px">
            {singleStudentData?.resume?.projects?.map((item, index) => (
              <InfoSection
                resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>

          <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.resume?.internships?.length ? (
        <Fragment>
          <MainHeading>Internship</MainHeading>
          <SubFLex column gap="25px">
            {singleStudentData?.resume?.internships?.map((item, index) => (
              <InfoSection
                resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>

          <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.resume?.courses?.length ? (
        <Fragment>
          <MainHeading>Courses</MainHeading>
          <SubFLex column gap="25px">
            {singleStudentData?.resume?.courses?.map((item, index) => (
              <InfoSection
              resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>

          <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.resume?.training?.length ? (
        <Fragment>
          <MainHeading>Training</MainHeading>
          <SubFLex column gap="25px">
            {singleStudentData?.resume?.training?.map((item, index) => (
              <InfoSection
                resume={true}
                key={index + item?.title}
                name={item?.title}
                company={item?.organization}
                work={item?.description}
                skills={item?.skill_set}
                duration={`${item?.started_in}- ${item?.ended_in}`}
              />
            ))}
          </SubFLex>

          <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.resume?.awards?.length ? (
        <Fragment>
          <HonorsAwardsSection awards={singleStudentData?.resume?.awards} />
          <StyledDivider />
        </Fragment>
      ) : null}
      {singleStudentData?.resume?.workExperience?.length ? (
        <Fragment>
          <WorkExperienceSection
           resume={true}
            experience={singleStudentData?.resume?.workExperience}
          />
          <StyledDivider />
        </Fragment>
      ) : null}

      {singleStudentData?.currentCourse?.educationLevel ? (
        <Fragment>
          <CurrentlyPursuingDetails
            studentData={singleStudentData?.currentCourse}
          />

          <StyledDivider />
        </Fragment>
      ) : null}
      {singleStudentData?.studentPersonalProfile?.socialMedia?.length ? (
        <Fragment>
          <SocialMediaLinks studentData={singleStudentData} />

          <StyledDivider />
        </Fragment>
      ) : null}

      <OtherDetails studentData={singleStudentData} />
    </Main>
  )
}

export default StudentDrawerContent
